export default value => !!(value && value.__CANCEL__)
